import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

// Warns before unsaved changes are lost, two ways:
// - beforeunload covers the browser leaving the app entirely (close tab, refresh, typing a new URL).
// - useBlocker covers in-app navigation (Link clicks, navigate() calls, back/forward within the SPA).
// useBlocker requires a "data router" (createBrowserRouter + RouterProvider) — App.js wraps the whole
// app in one for exactly this reason. Calling it under a plain <BrowserRouter> throws immediately.
export default function useUnsavedChangesGuard(dirty) {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (dirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [dirty]);

  return useBlocker(
    ({ currentLocation, nextLocation }) =>
      dirty && currentLocation.pathname !== nextLocation.pathname
  );
}
